import React, { useEffect } from 'react';
import './styles/DraftLeague.css';
import { Link } from 'react-router-dom';
import basketballImg from './assets/basketball.png';

const HoopChallenge = () => {
  useEffect(() => {
    document.documentElement.style.setProperty(
      '--basketball-image',
      `url(${basketballImg})`
    );
  }, []);

  const sectionStyle = {
    flexDirection: 'column',
    alignItems: 'center',
  };

  const imageStyle = {
    height: 'auto',
    objectFit: 'contain',
    maxWidth: '100%',
  };

  return (
    <div className="draft-league-container">
      <div className="hero">
        {/* Background */}
        <div className="hero-background" />
        <div className="hero-overlay" />

        {/* Floating elements */}
        <div className="floating-element-1" />
        <div className="floating-element-2" />
        <div className="floating-element-3" />

        {/* Main Content */}
        <div className="hero-content">
          <Link to="/" className="hero-link" style={{ textDecoration: 'none' }}>
            <h1 className="hero-title">
              Grass Valley
              <br />
              <span className="hero-title-bold">Draft League</span>
            </h1>
          </Link>

          <div className="about-sections">
            {/* Hero Section */}
            <div className="about-section">
              <div className="about-content" style={sectionStyle}>
                <div className="about-text">
                  <h2 className="about-title">The 100 Hoop Challenge</h2>
                  <p className="about-description">
                    A fast-paced basketball shooting competition and fundraiser
                    hosted by Boys to Men NorCal.
                  </p>
                  <p className="about-description">
                    <strong>Next Event: June 2027</strong>
                  </p>
                  <h3 className="about-subtitle">Two Ways to Join</h3>
                  <ul className="about-features">
                    <li>
                      <strong>Compete:</strong> Register as a shooter and
                      fundraise to unlock prizes.
                    </li>
                    <li>
                      <strong>Attend & Support:</strong> Enjoy live music and
                      burgers, sponsor a shooter, and help rebound.
                    </li>
                  </ul>
                </div>
                <div className="about-image">
                  <img
                    src="/100hoop/3.jpg"
                    alt="100 Hoop Challenge"
                    className="section-image"
                    style={imageStyle}
                  />
                </div>
              </div>
            </div>

            {/* What It Is */}
            <div className="about-section">
              <div className="about-content" style={sectionStyle}>
                <div className="about-text">
                  <h2 className="about-title">What It Is</h2>
                  <ul className="about-features">
                    <li>15 minutes - 100 shots - designated court spots</li>
                    <li>
                      Think NBA 3-Point Contest—more time, way more shots.
                    </li>
                    <li>Tests focus, endurance, and pure shooting skill.</li>
                  </ul>
                </div>
                <div className="about-image">
                  <img
                    src="/100hoop/1.jpg"
                    alt="100 Hoop Challenge"
                    className="section-image"
                    style={imageStyle}
                  />
                </div>
              </div>
            </div>

            {/* Fundraising & Prizes */}
            <div className="about-section">
              <div className="about-content" style={sectionStyle}>
                <div className="about-text">
                  <h2 className="about-title">Fundraising & Prizes</h2>
                  <ul className="about-features">
                    <li>
                      Get pledges before you shoot; every dollar supports youth
                      mentorship.
                    </li>
                    <li>
                      Prize tiers: $250 (Tier 1), $500 (Tier 2), $750 (Tier 3),
                      and up.
                    </li>
                    <li>
                      All shooters get a T-shirt + "100 Hoop" performance poster.
                    </li>
                    <li>
                      Extra prizes for top shooters and top fundraisers (min $250
                      raised).
                    </li>
                  </ul>
                </div>
                <div className="about-image">
                  <img
                    src="/100hoop/4.jpg"
                    alt="100 Hoop Challenge Prizes"
                    className="section-image"
                    style={imageStyle}
                  />
                </div>
              </div>
            </div>

            {/* Benefiting */}
            <div className="about-section">
              <div className="about-content" style={sectionStyle}>
                <div className="about-text">
                  <h2 className="about-title">Benefiting</h2>
                  <p className="about-description">
                    <a
                      href="https://www.boystomennorcal.org"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Boys to Men Mentoring Network of Northern California
                    </a>{' '}
                    (501(c)(3)) — mentorship, outdoor adventures, sports programs,
                    and material support for local families.
                  </p>
                </div>
                <div className="about-image">
                  <img
                    src="/100hoop/2.jpg"
                    alt="Boys to Men NorCal"
                    className="section-image"
                    style={imageStyle}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="cards-container">
            <Link to="/" className="card-link">
              <div className="card">
                <h3 className="card-title">Home</h3>
              </div>
            </Link>
          </div>
        </div>
      </div>

      {/* Footer */}
      <div className="footer">
        <div className="footer-content">
          <p className="footer-text">
            &copy; 2026 Boys to Men NorCal. All rights reserved.
          </p>
        </div>
      </div>
    </div>
  );
};

export default HoopChallenge;
